// Cap width and compression on stock (pexels/unsplash) image URLs to speed up hero loads.
export const optimizeImg = (url, w = 1200) => {
  if (!url || !/^https?:\/\//i.test(url)) return url;
  try {
    const u = new URL(url);
    if (/(pexels|unsplash)\.com$/.test(u.hostname) || /(pexels|unsplash)\.com/.test(u.hostname)) {
      u.searchParams.set("auto", "compress");
      if (!u.searchParams.get("cs")) u.searchParams.set("cs", "tinysrgb");
      u.searchParams.set("w", String(w));
      u.searchParams.set("q", "70");
      u.searchParams.delete("h");
      u.searchParams.delete("dpr");
      return u.toString();
    }
  } catch (e) { console.error("optimizeImg failed", e); }
  return url;
};
